export const getSubdomain = (): string | null => {
  const { hostname } = window.location;

  const YOUR_DOMAINS = [
    "index-360.com",
    "marcelvilasis.com",
    "com.mx",
    "nutricion.org",
    "org.arg",
    "org.mx",
    "org.ar",
  ];
  const DEV_SUFFIXES = [".localhost", ".local"];
  const SPECIAL_PREFIXES = ["revista."];

  let cleanHost = hostname.split(":")[0];

  cleanHost = cleanHost.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  cleanHost = cleanHost.toLowerCase();

  if (cleanHost.startsWith("www.")) {
    cleanHost = cleanHost.slice(4);
  } else if (cleanHost.startsWith("www")) {
    if (cleanHost.length > 3 && !/[a-zA-Z0-9]/.test(cleanHost[3])) {
      cleanHost = cleanHost.slice(3);
    }
  }

  // CASO ESPECÍFICO: revista.nutricion.com → revista
  if (
    cleanHost === "revista.nutricion.org" ||
    cleanHost === "revista.nutricion.org.localhost"
  ) {
    return "revista";
  }

  let foundSpecialPrefix = false;
  for (const prefix of SPECIAL_PREFIXES) {
    if (cleanHost.startsWith(prefix)) {
      foundSpecialPrefix = true;
      cleanHost = cleanHost.slice(prefix.length);
      break;
    }
  }

  const parts = cleanHost.split(".");

  for (const suffix of DEV_SUFFIXES) {
    if (cleanHost.endsWith(suffix)) {
      if (foundSpecialPrefix && parts.length > 0) {
        return parts[0];
      }
      return parts.length > 1 ? parts[0] : null;
    }
  }

  const domain = parts.slice(-2).join(".");
  if (YOUR_DOMAINS.includes(domain) && parts.length > 2) {
    return parts[0];
  }

  if (parts.length === 2 && !YOUR_DOMAINS.includes(cleanHost)) {
    return parts[0];
  }

  return null;
};
